import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * Cart Drawer Component
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();

    document.addEventListener(
      CartAddEvent.eventName,
      this.#handleCartAdd
    );

    /**
     * Reload page when drawer closes
     */
    this.addEventListener('click', (event) => {
      const closeBtn = event.target.closest(
        '[close], .drawer__close, .modal__close, .dialog-close'
      );

      if (closeBtn) {
        event.preventDefault();

        this.closeDialog();

        // Reload page after drawer closes
        setTimeout(() => {
          window.location.reload();
        }, 300);
      }
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener(
      CartAddEvent.eventName,
      this.#handleCartAdd
    );
  }

  /**
   * Auto open drawer after add to cart
   */
  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  /**
   * Open drawer
   */
  open() {
    this.showDialog();

    /**
     * Shopify installments fix
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent =
        document.querySelector('shopify-payment-terms')?.shadowRoot;

      const cta =
        installmentsContent?.querySelector(
          '#shopify-installments-cta'
        );

      cta?.addEventListener(
        'click',
        () => {
          this.closeDialog();

          setTimeout(() => {
            window.location.reload();
          }, 300);
        },
        { once: true }
      );
    });
  }

  /**
   * Close drawer
   */
  close() {
    this.closeDialog();

    // Reload page
    setTimeout(() => {
      window.location.reload();
    }, 300);
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define(
    'cart-drawer-component',
    CartDrawerComponent
  );
}